module.exports = __webpack_public_path__ + "static/media/37.8d013f7f.jpg";